import React from 'react';
import ProjectContainer from '@src/containers/Project';

const Project = () => <ProjectContainer />;

export default Project;
